import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AddIcon from '@mui/icons-material/Add';
import PersonIcon from '@mui/icons-material/Person';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';
import React from 'react';
const emails = ['username@gmail.com', 'user02@gmail.com'];
function SimpleDialog(props) {
    const { onClose, selectedValue, open } = props;
    const handleClose = () => {
        onClose(selectedValue);
    };
    const handleListItemClick = (value) => {
        onClose(value);
    };
    return (_jsxs(Dialog, Object.assign({ onClose: handleClose, "aria-labelledby": "simple-dialog-title", open: open }, { children: [_jsx(DialogTitle, Object.assign({ id: "simple-dialog-title" }, { children: "Set backup account" })), _jsxs(List, { children: [emails.map((email) => (_jsxs(ListItem, Object.assign({ button: true, onClick: () => handleListItemClick(email) }, { children: [_jsx(ListItemAvatar, { children: _jsx(Avatar, Object.assign({ sx: {
                                        backgroundColor: blue[100],
                                        color: blue[600],
                                    } }, { children: _jsx(PersonIcon, {}) })) }), _jsx(ListItemText, { primary: email })] }), email))), _jsxs(ListItem, Object.assign({ autoFocus: true, button: true, onClick: () => handleListItemClick('addAccount') }, { children: [_jsx(ListItemAvatar, { children: _jsx(Avatar, { children: _jsx(AddIcon, {}) }) }), _jsx(ListItemText, { primary: "Add account" })] }))] })] })));
}
export default function DialogExample() {
    const [open, setOpen] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState(emails[1]);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = (value) => {
        setOpen(false);
        setSelectedValue(value);
    };
    return (_jsxs("div", { children: [_jsxs(Typography, Object.assign({ variant: "subtitle1" }, { children: ["Selected: ", selectedValue] })), _jsx("br", {}), _jsx(Button, Object.assign({ variant: "outlined", color: "primary", onClick: handleClickOpen }, { children: "Open simple dialog" })), _jsx(SimpleDialog, { selectedValue: selectedValue, open: open, onClose: handleClose })] }));
}
